export default __webpack_public_path__ + "static/media/interface_visual.68f902e8.svg";